var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import rp from 'request-promise';
/**
   * 获取隐私等信息
   *   隐私链接：app_info.privacy_agreement
   *   开发者：app_info.developer
   *   更新时间：apk_all_data.publish_time
   *   版本：apk_all_data.version_name
   *   权限：apk_all_data.permissions
   * @param packagename
   */
export var getApkAccessInfoFromUpage = function (packagename) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, options, data, ret, app_detail_records, appDetailInfo, appInfo, apkData, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                headers = {
                    "Content-Type": "application/json; charset=UTF-8",
                };
                options = {
                    method: 'POST',
                    url: 'https://upage.html5.qq.com/wechat-apkinfo',
                    withCredentials: true,
                    headers: headers,
                    body: { packagename: packagename },
                    json: true,
                };
                return [4 /*yield*/, rp(options)];
            case 1:
                data = _a.sent();
                ret = data.ret, app_detail_records = data.app_detail_records;
                appDetailInfo = app_detail_records === null || app_detail_records === void 0 ? void 0 : app_detail_records[packagename];
                if (ret !== 0 || appDetailInfo === undefined) {
                    throw new Error('未查找到APP信息内容');
                }
                appInfo = appDetailInfo.app_info, apkData = appDetailInfo.apk_all_data;
                return [2 /*return*/, {
                        privacyAgreement: appInfo.privacy_agreement,
                        developer: appInfo.developer,
                        publishTime: apkData.publish_time,
                        versionName: apkData.version_name,
                        permissionUrl: PackagePermissionURL[packagename],
                    }];
            case 2:
                e_1 = _a.sent();
                console.error(e_1.message);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
var PackagePermissionURL = {
    'com.tencent.mtt': 'https://upage.imtt.qq.com/app-info/qb.html',
};
export var permissionsObj = {
    'android.permission.ACCESS_CHECKIN_PROPERTIES': {
        title: '访问登记属性',
        desc: '读取或写入登记check-in数据库属性表的权限',
    },
    'android.permission.ACCESS_COARSE_LOCATION': {
        title: '获取错略位置',
        desc: '通过WiFi或移动基站的方式获取用户错略的经纬度信息,定位精度大概误差在30~1500米',
    },
    'android.permission.ACCESS_FINE_LOCATION': {
        title: '获取精确位置',
        desc: '通过GPS芯片接收卫星的定位信息,定位精度达10米以内',
    },
    'android.permission.ACCESS_LOCATION_EXTRA_COMMANDS': {
        title: '访问定位额外命令',
        desc: '允许程序访问额外的定位提供者指令',
    },
    'android.permission.ACCESS_MOCK_LOCATION': {
        title: '获取模拟定位信息',
        desc: '获取模拟定位信息,一般用于帮助开发者调试应用',
    },
    'android.permission.ACCESS_NETWORK_STATE': {
        title: '获取网络状态',
        desc: '获取网络信息状态,如当前的网络连接是否有效',
    },
    'android.permission.ACCESS_SURFACE_FLINGER': {
        title: '访问Surface',
        desc: 'Flinger',
    },
    'android.permission.ACCESS_WIFI_STATE': {
        title: '获取WiFi状态',
        desc: '获取当前WiFi接入的状态以及WLAN热点的信息',
    },
    'android.permission.ACCOUNT_MANAGER': {
        title: '账户管理',
        desc: '获取账户验证信息,主要为GMail账户信息,只有系统级进程才能访问的权限',
    },
    'android.permission.AUTHENTICATE_ACCOUNTS': {
        title: '验证账户',
        desc: '允许一个程序通过账户验证方式访问账户管理ACCOUNT_MANAGER相关信息',
    },
    'android.permission.BATTERY_STATS': {
        title: '电量统计',
        desc: '获取电池电量统计信息',
    },
    'android.permission.BIND_APPWIDGET': {
        title: '绑定小插件',
        desc: '允许一个程序告诉appWidget服务需要访问小插件的数据库,只有非常少的应用才用到此权限',
    },
    'android.permission.BIND_DEVICE_ADMIN': {
        title: '绑定设备管理',
        desc: '请求系统管理员接收者receiver,只有系统才能使用',
    },
    'android.permission.BIND_INPUT_METHOD': {
        title: '绑定输入法',
        desc: '请求InputMethodService服务,只有系统才能使用',
    },
    'android.permission.BIND_REMOTEVIEWS': {
        title: '绑定RemoteView',
        desc: '必须通过RemoteViewsService服务来请求,只有系统才能用',
    },
    'android.permission.BIND_WALLPAPER': {
        title: '绑定壁纸',
        desc: '必须通过WallpaperService服务来请求,只有系统才能用',
    },
    'android.permission.BLUETOOTH': {
        title: '使用蓝牙',
        desc: '允许程序连接配对过的蓝牙设备',
    },
    'android.permission.BLUETOOTH_ADMIN': {
        title: '蓝牙管理',
        desc: '允许程序进行发现和配对新的蓝牙设备',
    },
    'android.permission.BRICK': {
        title: '变成砖头',
        desc: '能够禁用手机,非常危险,顾名思义就是让手机变成砖头',
    },
    'android.permission.BROADCAST_PACKAGE_REMOVED': {
        title: '应用删除时广播',
        desc: '当一个应用在删除时触发一个广播',
    },
    'android.permission.BROADCAST_SMS': {
        title: '收到短信时广播',
        desc: '当收到短信时触发一个广播',
    },
    'android.permission.BROADCAST_STICKY': {
        title: '连续广播',
        desc: '允许一个程序收到广播后快速收到下一个广播',
    },
    'android.permission.BROADCAST_WAP_PUSH': {
        title: 'WAP',
        desc: 'PUSH广播',
    },
    'android.permission.CALL_PHONE': {
        title: '拨打电话',
        desc: '允许程序从非系统拨号器里输入电话号码',
    },
    'android.permission.CALL_PRIVILEGED': {
        title: '通话权限',
        desc: '允许程序拨打电话,替换系统的拨号器界面',
    },
    'android.permission.CAMERA': {
        title: '拍照权限',
        desc: '允许访问摄像头进行拍照',
    },
    'android.permission.CHANGE_COMPONENT_ENABLED_STATE': {
        title: '改变组件状态',
        desc: '改变组件是否启用状态',
    },
    'android.permission.CHANGE_CONFIGURATION': {
        title: '改变配置',
        desc: '允许当前应用改变配置,如定位',
    },
    'android.permission.CHANGE_NETWORK_STATE': {
        title: '改变网络状态',
        desc: '改变网络状态如是否能联网',
    },
    'android.permission.CHANGE_WIFI_MULTICAST_STATE': {
        title: '改变WiFi多播状态',
        desc: '改变WiFi多播状态',
    },
    'android.permission.CHANGE_WIFI_STATE': {
        title: '改变WiFi状态',
        desc: '改变WiFi状态',
    },
    'android.permission.CLEAR_APP_CACHE': {
        title: '清除应用缓存',
        desc: '清除应用缓存',
    },
    'android.permission.CLEAR_APP_USER_DATA': {
        title: '清除用户数据',
        desc: '清除应用的用户数据',
    },
    'android.permission.CWJ_GROUP': {
        title: '底层访问权限',
        desc: '允许CWJ账户组访问底层信息',
    },
    'android.permission.CELL_PHONE_MASTER_EX': {
        title: '手机优化大师扩展权限',
        desc: '手机优化大师扩展权限',
    },
    'android.permission.CONTROL_LOCATION_UPDATES': {
        title: '控制定位更新',
        desc: '允许获得移动网络定位信息改变',
    },
    'android.permission.DELETE_CACHE_FILES': {
        title: '删除缓存文件',
        desc: '允许应用删除缓存文件',
    },
    'android.permission.DELETE_PACKAGES': {
        title: '删除应用',
        desc: '允许程序删除应用',
    },
    'android.permission.DEVICE_POWER': {
        title: '电源管理',
        desc: '允许访问底层电源管理',
    },
    'android.permission.DIAGNOSTIC': {
        title: '应用诊断',
        desc: '允许程序到RW到诊断资源',
    },
    'android.permission.DISABLE_KEYGUARD': {
        title: '禁用键盘锁',
        desc: '允许程序禁用键盘锁',
    },
    'android.permission.DUMP': {
        title: '转存系统信息',
        desc: '允许程序获取系统dump信息从系统服务',
    },
    'android.permission.EXPAND_STATUS_BAR': {
        title: '状态栏控制',
        desc: '允许程序扩展或收缩状态栏',
    },
    'android.permission.FACTORY_TEST': {
        title: '工厂测试模式',
        desc: '允许程序运行工厂测试模式',
    },
    'android.permission.FLASHLIGHT': {
        title: '使用闪光灯',
        desc: '允许访问闪光灯',
    },
    'android.permission.FORCE_BACK': {
        title: '强制后退',
        desc: '允许程序强制使用back后退按键,无论Activity是否在顶层',
    },
    'android.permission.GET_ACCOUNTS': {
        title: '访问账户Gmail列表',
        desc: '访问GMail账户列表',
    },
    'android.permission.GET_PACKAGE_SIZE': {
        title: '获取应用大小',
        desc: '获取应用的文件大小',
    },
    'android.permission.GET_TASKS': {
        title: '获取任务信息',
        desc: '允许程序获取当前或最近运行的应用',
    },
    'android.permission.GLOBAL_SEARCH': {
        title: '允许全局搜索',
        desc: '允许程序使用全局搜索功能',
    },
    'android.permission.HARDWARE_TEST': {
        title: '硬件测试',
        desc: '访问硬件辅助设备,用于硬件测试',
    },
    'android.permission.INJECT_EVENTS': {
        title: '注射事件',
        desc: '允许访问本程序的底层事件,获取按键、轨迹球的事件流',
    },
    'android.permission.INSTALL_LOCATION_PROVIDER': {
        title: '安装定位提供',
        desc: '安装定位提供',
    },
    'android.permission.INSTALL_PACKAGES': {
        title: '安装应用程序',
        desc: '允许程序安装应用',
    },
    'android.permission.INTERNAL_SYSTEM_WINDOW': {
        title: '内部系统窗口',
        desc: '允许程序打开内部窗口,不对第三方应用程序开放此权限',
    },
    'android.permission.INTERNET': {
        title: '访问网络',
        desc: '访问网络连接,可能产生GPRS流量',
    },
    'android.permission.KILL_BACKGROUND_PROCESSES': {
        title: '结束后台进程',
        desc: '允许程序调用killBackgroundProcesses(String).方法结束后台进程',
    },
    'android.permission.MANAGE_ACCOUNTS': {
        title: '管理账户',
        desc: '允许程序管理AccountManager中的账户列表',
    },
    'android.permission.MANAGE_APP_TOKENS': {
        title: '管理程序引用',
        desc: '管理创建、摧毁、Z轴顺序,仅用于系统',
    },
    'android.permission.MTWEAK_USER': {
        title: '高级权限',
        desc: '允许mTweak用户访问高级系统权限',
    },
    'android.permission.MTWEAK_FORUM': {
        title: '社区权限',
        desc: '允许使用mTweak社区权限',
    },
    'android.permission.MASTER_CLEAR': {
        title: '软格式化',
        desc: '允许程序执行软格式化,删除系统配置信息',
    },
    'android.permission.MODIFY_AUDIO_SETTINGS': {
        title: '修改声音设置',
        desc: '修改声音设置信息',
    },
    'android.permission.MODIFY_PHONE_STATE': {
        title: '修改电话状态',
        desc: '修改电话状态,如飞行模式,但不包含替换系统拨号器界面',
    },
    'android.permission.MOUNT_FORMAT_FILESYSTEMS': {
        title: '格式化文件系统',
        desc: '格式化可移动文件系统,比如格式化清空SD卡',
    },
    'android.permission.MOUNT_UNMOUNT_FILESYSTEMS': {
        title: '挂载文件系统',
        desc: '挂载、反挂载外部文件系统',
    },
    'android.permission.NFC': {
        title: '允许NFC通讯',
        desc: '允许程序执行NFC近距离通讯操作,用于移动支持',
    },
    'android.permission.PERSISTENT_ACTIVITY': {
        title: '永久Activity',
        desc: '创建一个永久的Activity,该功能标记为将来将被移除',
    },
    'android.permission.PROCESS_OUTGOING_CALLS': {
        title: '处理拨出电话',
        desc: '允许程序监视,修改或放弃播出电话',
    },
    'android.permission.READ_CALENDAR': {
        title: '读取日程提醒',
        desc: '允许程序读取用户的日程信息',
    },
    'android.permission.READ_CONTACTS': {
        title: '读取联系人',
        desc: '允许应用访问联系人通讯录信息',
    },
    'android.permission.READ_FRAME_BUFFER': {
        title: '屏幕截图',
        desc: '读取帧缓存用于屏幕截图',
    },
    'com.android.browser.permission.READ_HISTORY_BOOKMARKS': {
        title: '读取收藏夹和历史记录',
        desc: '读取浏览器收藏夹和历史记录',
    },
    'android.permission.READ_INPUT_STATE': {
        title: '读取输入状态',
        desc: '读取当前键的输入状态,仅用于系统',
    },
    'android.permission.READ_LOGS': {
        title: '读取系统日志',
        desc: '读取系统底层日志',
    },
    'android.permission.READ_PHONE_STATE': {
        title: '读取电话状态',
        desc: '访问电话状态',
    },
    'android.permission.READ_SMS': {
        title: '读取短信内容',
        desc: '读取短信内容',
    },
    'android.permission.READ_SYNC_SETTINGS': {
        title: '读取同步设置',
        desc: '读取同步设置,读取Google在线同步设置',
    },
    'android.permission.READ_SYNC_STATS': {
        title: '读取同步状态',
        desc: '读取同步状态,获得Google在线同步状态',
    },
    'android.permission.REBOOT': {
        title: '重启设备',
        desc: '允许程序重新启动设备',
    },
    'android.permission.RECEIVE_BOOT_COMPLETED': {
        title: '开机自动允许',
        desc: '允许程序开机自动运行',
    },
    'android.permission.RECEIVE_MMS': {
        title: '接收彩信',
        desc: '接收彩信',
    },
    'android.permission.RECEIVE_SMS': {
        title: '接收短信',
        desc: '接收短信',
    },
    'android.permission.RECEIVE_WAP_PUSH': {
        title: '接收Wap',
        desc: 'Push',
    },
    'android.permission.RECORD_AUDIO': {
        title: '录音',
        desc: '录制声音通过手机或耳机的麦克',
    },
    'android.permission.REORDER_TASKS': {
        title: '排序系统任务',
        desc: '重新排序系统Z轴运行中的任务',
    },
    'android.permission.RESTART_PACKAGES': {
        title: '结束系统任务',
        desc: '结束任务通过restartPackage(String)方法,该方式将在外来放弃',
    },
    'android.permission.SEND_SMS': {
        title: '发送短信',
        desc: '发送短信',
    },
    'android.permission.SET_ACTIVITY_WATCHER': {
        title: '设置Activity观察其',
        desc: '设置Activity观察器一般用于monkey测试',
    },
    'com.android.alarm.permission.SET_ALARM': {
        title: '设置闹铃提醒',
        desc: '设置闹铃提醒',
    },
    'android.permission.SET_ALWAYS_FINISH': {
        title: '设置总是退出',
        desc: '设置程序在后台是否总是退出',
    },
    'android.permission.SET_ANIMATION_SCALE': {
        title: '设置动画缩放',
        desc: '设置全局动画缩放',
    },
    'android.permission.SET_DEBUG_APP': {
        title: '设置调试程序',
        desc: '设置调试程序,一般用于开发',
    },
    'android.permission.SET_ORIENTATION': {
        title: '设置屏幕方向',
        desc: '设置屏幕方向为横屏或标准方式显示,不用于普通应用',
    },
    'android.permission.SET_PREFERRED_APPLICATIONS': {
        title: '设置应用参数',
        desc: '设置应用的参数,已不再工作具体查看addPackageToPreferred(String)介绍',
    },
    'android.permission.SET_PROCESS_LIMIT': {
        title: '设置进程限制',
        desc: '允许程序设置最大的进程数量的限制',
    },
    'android.permission.SET_TIME': {
        title: '设置系统时间',
        desc: '设置系统时间',
    },
    'android.permission.SET_TIME_ZONE': {
        title: '设置系统时区',
        desc: '设置系统时区',
    },
    'android.permission.SET_WALLPAPER': {
        title: '设置桌面壁纸',
        desc: '设置桌面壁纸',
    },
    'android.permission.SET_WALLPAPER_HINTS': {
        title: '设置壁纸建议',
        desc: '设置壁纸建议',
    },
    'android.permission.SIGNAL_PERSISTENT_PROCESSES': {
        title: '发送永久进程信号',
        desc: '发送一个永久的进程信号',
    },
    'android.permission.STATUS_BAR': {
        title: '状态栏控制',
        desc: '允许程序打开、关闭、禁用状态栏',
    },
    'android.permission.SUBSCRIBED_FEEDS_READ': {
        title: '访问订阅内容',
        desc: '访问订阅信息的数据库',
    },
    'android.permission.SUBSCRIBED_FEEDS_WRITE': {
        title: '写入订阅内容',
        desc: '写入或修改订阅内容的数据库',
    },
    'android.permission.SYSTEM_ALERT_WINDOW': {
        title: '显示系统窗口',
        desc: '显示系统窗口',
    },
    'android.permission.UPDATE_DEVICE_STATS': {
        title: '更新设备状态',
        desc: '更新设备状态',
    },
    'android.permission.USE_CREDENTIALS': {
        title: '使用证书',
        desc: '允许程序请求验证从AccountManager',
    },
    'android.permission.USE_SIP': {
        title: '使用SIP视频',
        desc: '允许程序使用SIP视频服务',
    },
    'android.permission.VIBRATE': {
        title: '使用振动',
        desc: '允许振动',
    },
    'android.permission.WAKE_LOCK': {
        title: '唤醒锁定',
        desc: '允许程序在手机屏幕关闭后后台进程仍然运行',
    },
    'android.permission.WRITE_APN_SETTINGS': {
        title: '写入GPRS接入点设置',
        desc: '写入网络GPRS接入点设置',
    },
    'android.permission.WRITE_CALENDAR': {
        title: '写入日程提醒',
        desc: '写入日程,但不可读取',
    },
    'android.permission.WRITE_CONTACTS': {
        title: '写入联系人',
        desc: '写入联系人,但不可读取',
    },
    'android.permission.WRITE_EXTERNAL_STORAGE': {
        title: '写入外部存储',
        desc: '允许程序写入外部存储,如SD卡上写文件',
    },
    'android.permission.WRITE_GSERVICES': {
        title: '写入Google地图数据',
        desc: '允许程序写入Google',
    },
    'com.android.browser.permission.WRITE_HISTORY_BOOKMARKS': {
        title: '写入收藏夹和历史记录',
        desc: '写入浏览器历史记录或收藏夹,但不可读取',
    },
    'android.permission.WRITE_SECURE_SETTINGS': {
        title: '读写系统敏感设置',
        desc: '允许程序读写系统安全敏感的设置项',
    },
    'android.permission.WRITE_SETTINGS': {
        title: '读写系统设置',
        desc: '允许读写系统设置项',
    },
    'android.permission.WRITE_SMS': {
        title: '编写短信',
        desc: '允许编写短信',
    },
};
